import React, { lazy } from 'react';
import { createPage } from '@edreamsodigeo/frontend-core';
export const page = 'homePage';
export const HomePage = createPage(page, /*#__PURE__*/lazy(() => import(/* webpackChunkName: "home_page" */
/* webpackPrefetch: true */
'./HomePage')));
export const HomeFunnel = () => /*#__PURE__*/React.createElement(HomePage, null);